import { useRef, useState } from "react";

import { useQueryClient } from "@tanstack/react-query";
import { toast, ToastContainer } from "react-toastify";

import { QueryKeys } from "../../../../utils/queryKeys";

import SuccessIcon from '../../../../assets/images/success-icon.svg';
import CameraIcon from '../../../../assets/images/assessment-camera.svg';
import GalleryIcon from '../../../../assets/images/photo-gallery.svg';
import FileIcon from '../../../../assets/images/upload-file.svg';


import Button from "../../lms/ButtonComponent";
import { BUTTON_VARIANTS } from "../../lms/constant";

import { useUploadDocument } from "../mutation";

import styles from "./styles.module.scss";
import { useGetTranslatedText } from "../../lms/queries";
import { getTranslatedText } from "../../../../utils/getTranslatedText";
import { uploadDocumentApiCall } from "../utils.api";

const MAX_FILES = 3;
const MAX_SIZE = 2 * 1024 * 1024; // 2MB
const ALLOWED_TYPES = ["image/jpeg", "image/png", "application/pdf"];


const DocumentUploadModal = ({setOpenCamera , setOpenDocumentModal , files , setFiles , setDocumentUploadedSuccessfully}) => {
  const fileInputRef = useRef(null);

  const [error, setError] = useState("");
  const [loading , setLoading] = useState(false);

  // const { mutate , isPending } = useUploadDocument();

  const queryClient = useQueryClient();

  const handleFiles = (selectedFiles) => {
    if (!selectedFiles) return;

    let newFiles = [...files];
    let errorMsg = "";

    Array.from(selectedFiles).forEach((file) => {
      if (newFiles.length >= MAX_FILES) {
        errorMsg = "Maximum 3 files allowed";
        return;
      }

      if (!ALLOWED_TYPES.includes(file.type)) {
        errorMsg = "Only JPG, PNG, PDF allowed";
        return;
      }

      if (file.size > MAX_SIZE) {
        errorMsg = "File size must be less than 2MB";
        return;
      }

      newFiles.push(file);
    });

    setFiles(newFiles);
    setError(errorMsg);
  };

  const handleBrowse = () => {
    fileInputRef.current?.click();
  };

  const handleRemove = (index) => {
    const updated = [...files];
    updated.splice(index, 1);
    setFiles(updated);
  };

  const languageId = localStorage.getItem("l_id") || 1;
    
  const { data: translatedTextResponse } = useGetTranslatedText(languageId);
    
  const { data: translatedText = [] } = translatedTextResponse || {};

  const handleSubmit = async () => {
    try {
       setLoading(true);
       const response  = await uploadDocumentApiCall(files)

      const { status, error} = response || {};

        if (!status) throw new Error(error);

        queryClient.invalidateQueries({
            queryKey: [QueryKeys.FINAL_ASSESSMENT_KEYS], // use your actual query key
        });

        setOpenDocumentModal(false);
        setDocumentUploadedSuccessfully(true);
        toast.success('Document uploaded successfully.');
    } catch (error) {
      
    }finally{
      setLoading(false);
    }
   

  //  mutate(files,{
  //    onSuccess: (response) => {
  //       const { status, error} = response?.data || {};

  //       if (!status) throw new Error(error);
    
  //       queryClient.invalidateQueries({
  //           queryKey: [QueryKeys.FINAL_ASSESSMENT_KEYS], // use your actual query key
  //       });

  //       setOpenDocumentModal(false);
  //       setDocumentUploadedSuccessfully(true);
  //       toast.success('Document uploaded successfully.');
  //     },
  //  })
  };

  const handleCamera = () => {
    setOpenCamera(true);
    setOpenDocumentModal(false);
  }

  const handleCancel = () => {
    setOpenDocumentModal(false);
  }


  return (
    <>
   
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.header}>
          <h3 className={styles.heading}>
             {
              getTranslatedText(
                translatedText,
                "documents_to_upload",
                "Documents to Upload :",
              )} 
            </h3>
          <ul className={styles['criteria-list']}>
            <li className={styles.criteria}> 
                <img src={SuccessIcon} className={styles['success-icon']} alt="success-icon" />
                {
                  getTranslatedText(
                translatedText,
                "txt1",
                `Upload a clear photo of the complete TLM. 
                The TLM should be handmade or adapted according to the child’s learning needs.`,
              )
                }
                </li>
            <li className={styles.criteria}>
            <img src={SuccessIcon} className={styles['success-icon']} alt="success-icon" />
             {
                  getTranslatedText(
                translatedText,
                "txt2",
                `Attach a short document explaining the Domain, Sub-domain, 
              Target Skill, and how it supported the child’s learning.`,
              )
                }
              
            </li>
          </ul>
        </div>

        {/* Upload Box */}
        <div className={styles.uploadBox}>
          <div className={styles.icon}>
            <img src={FileIcon} alt="file-icon" />
          </div>

          <p className={styles.title}>
            Upload multiple documents (max 3 files)
          </p>
          <p className={styles.subtitle}>
             {
                getTranslatedText(
                translatedText,
                "upload_desc",
                `Supported: JPG, PNG, PDF | Max: 2MB`,
              )
              }
          </p>

          <div className={styles.actions}>
            <button className={styles.btn} onClick={handleCamera}><img className={styles['success-icon']} src={CameraIcon} alt="camera" />
            {
                getTranslatedText(
                translatedText,
                "camera",
                `Camera`,
              )
             }
             
            </button>
            <button className={styles.btn} onClick={handleBrowse}>
             <img className={styles['success-icon']} src={GalleryIcon} alt="camera" /> 
             {
                getTranslatedText(
                translatedText,
                "browse_file",
                `Browse file`,
              )
             }
            
            </button>
          </div>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            hidden
            onChange={(e) => handleFiles(e.target.files)}
          />

          {error && <p className={styles.error}>{error}</p>}
        </div>

         {
        files.length
        ?
        <>   
        <div className={styles['d-flex']}>
            <p className={styles['uploaded-files']}>Upload files ({files.length}) </p>
            <p className={styles['submit-ready']}>
            <span className={styles['submit-text']}>Ready to submit</span>
            <img src={SuccessIcon} alt='' />
            </p>
            </div>
          <div className={styles.fileList}>
            {files.map((file, index) => (
              <div key={index} className={styles.fileItem}>
                <span>{file.name}</span>
                <button onClick={() => handleRemove(index)}>❌</button>
              </div>
            ))}
        </div>
          </>
          :null
         }


        {/* Footer */}
        <div className={styles.footer}>
           <Button 
          label={
            getTranslatedText(
                translatedText,
                "label_cancel",
                `Cancel`,
            )
          } 
          buttonVariant={BUTTON_VARIANTS.SECONDARY} 
          className={styles.cancelBtn}
          onClick={handleCancel} 
        />
        <Button 
          label={ 
            loading
            ?
            'Loading...'
            :
             getTranslatedText(
                translatedText,
                "submit_btn",
                `Submit`,
            )
          } 
          buttonVariant={BUTTON_VARIANTS.PRIMARY} 
          disabled={files.length === 0 || loading } 
          onClick={handleSubmit} 
        />
        </div>
      </div>
    </div>
    <ToastContainer/>
    </>
  );
};

export default DocumentUploadModal;